module.exports = __webpack_public_path__ + "img/bubble.b47e6916.svg";